import { Button } from '@/components/ui/button'

export function PortalUnavailableCard({
  title,
  retrying,
  onRetry,
}: {
  title: string
  retrying: boolean
  onRetry: () => void
}) {
  return (
    <section className="portal-dashboard-panel p-4" aria-label={title}>
      <h2 className="text-sm font-semibold">{title}</h2>
      <p role="alert" className="my-2 text-sm text-muted-foreground">
        We couldn’t load this section. Try again to see the latest information.
      </p>
      <Button variant="outline" size="sm" disabled={retrying} onClick={onRetry}>
        {retrying ? 'Retrying…' : 'Try again'}
      </Button>
    </section>
  )
}
